






































import {Component, Prop, Vue, Watch} from 'vue-property-decorator';
import {Variant} from "../widgets/CartOverviewWidget/types";

@Component
export default class GSCartAmountInput extends Vue {
  @Prop() lineItemId!: number;
  @Prop() variant!: Variant;
  @Prop() qty!: number;
  @Prop() hasError!: boolean;
  @Prop({default: 0}) minValue!: number;
  @Prop({default: false}) disabled!: boolean;

  currentValue = 0;
  beigeDark = '#f0ebe5';
  variantId?: number | null = null;

  created() {
    this.currentValue = this.qty;
    this.variantId = this.variant.variant.purchasableId;
  }

  @Watch('qty')
  onOutValueChange(qty: number): void {
    this.currentValue = qty;
  }

  updateCartLineAmount(event: any): void {
    this.$emit('amount-updated', this.lineItemId, this.variantId, event.target.value);
  }

  increaseValue(): void {
    this.currentValue += 1;
    this.$emit('amount-updated', this.lineItemId, this.variantId, this.currentValue);
  }

  decreaseValue(): void {
    if (this.currentValue <= this.minValue) {
      this.currentValue = this.minValue;
      return;
    }

    this.currentValue -= 1;
    this.$emit('amount-updated', this.lineItemId, this.variantId, this.currentValue);
  }
}
